import React from 'react';

import MyNavbar from "../../../components/student/mynavbar/MyNavbar";
import Footer from "../../../components/student/footer/Footer";
import SolutionsTittle from "../../../screens/student/solutions/SolutionsTittle";
import SolutionsSec from './SolutionsSec';
import InvolvedSection from './InvolvedSection';

function Solutions() {
  return (
    // <div className="solutions-page">
    <>
      <MyNavbar />
      <SolutionsTittle />
      <SolutionsSec />
       <InvolvedSection />
      <Footer />
      </>
    // </div>
  );
}

export default Solutions;
